import { render, staticRenderFns } from "./folderPermissionDialog.vue?vue&type=template&id=0f04a554&scoped=true"
import script from "./folderPermissionDialog.vue?vue&type=script&lang=js"
export * from "./folderPermissionDialog.vue?vue&type=script&lang=js"
import style0 from "./folderPermissionDialog.vue?vue&type=style&index=0&id=0f04a554&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04a554",
  null
  
)

export default component.exports